import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { enumCompanyBusinessType } from '@app/data-layer/enums/companies';

@Component({
  selector: 'cbp-number-request-business-type-form',
  templateUrl: './cbp-number-request-business-type-form.component.html',
  styleUrls: ['./cbp-number-request-business-type-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbpNumberRequestBusinessTypeFormComponent implements OnInit {
  @Input() public formGroup: UntypedFormGroup;

  public enumCompanyBusinessType: typeof enumCompanyBusinessType = enumCompanyBusinessType;

  constructor() {}

  ngOnInit() {}
}
